import { Row } from "antd";
import { useHistory } from "react-router";
import {
  MdClass,
  MdAddCircleOutline,
  MdOutlineSettings,
  MdOutlineSync,
} from "react-icons/md";

import PageHeader from "./components/PageHeader/PageHeader";
import CadastroCard from "./components/CardCadastro";

import { Container } from "./styles";
import { useValidatePermission } from "core/features/auth/hooks/useValidatePermission";

function Cadastros() {
  const { push } = useHistory();
  const { hasPermission } = useValidatePermission();

  const cards = [
    {
      url: "/Cadastros/Classes-Operacao",
      icon: MdClass,
      permission: [
        "OperacaoClasse.Listar",
        "OperacaoClasse.Cadastrar",
        "OperacaoClasse.Alterar",
        "OperacaoClasse.Excluir",
      ],
      color: "#20a45a",
      text: "Classes de Operação",
    },
    {
      url: "/Cadastros/Configuracao-Filtros-Culturas",
      icon: MdOutlineSettings,
      permission: ["Ocupacao.Listar", "Operacao.Alterar"],
      color: "#20a45a",
      text: "Configuração de Filtros de Culturas",
    },
    {
      url: "/Cadastros/Gestao-Jobs",
      icon: MdOutlineSync,
      permission: ["RecurringJobGroup.Listar"],
      color: "#20a45a",
      text: "Gestão de Jobs",
    },
  ];

  return (
    <Container>
      <PageHeader
        title="Cadastros"
        avatar={MdAddCircleOutline}
        avatarStyle={{
          color: "#fff",
          backgroundColor: "#20a45a",
          border: "1px solid #20a45a",
        }}
      />
      <Row style={{ padding: "0.5rem" }}>
        {cards.map(
          (card) =>
            hasPermission(card.permission, { match: "every" }) && (
              <CadastroCard
                onClick={() => push(card.url)}
                color={card.color}
                Icon={card.icon}
                text={card.text}
                dataTestId={card.text}
              />
            ),
        )}
      </Row>
    </Container>
  );
}

export default Cadastros;
